import React from 'react';

import { Slider, Button,Row,Col,Icon } from 'antd';

const style = {
    margin: 'auto',
    width:'50%',
  };

export default class PlaySlider extends React.Component {
  constructor(props){
    super(props);
    this.state={
      play:false,
      year:1985,
    };
    this.flipPlay=this.flipPlay.bind(this)
    this.reStart=this.reStart.bind(this)
  }

  componentDidMount(){
    if (this.state.year!==this.props.year){
      this.setState({year:this.props.year})
    }
    this.runStop()
  }

  flipPlay(){
    this.setState({play:!this.state.play})
  }


  updateYear=value=>{
    this.setState({year:value})
    this.props.setYear(value);
  }

  setYear(year){
    this.setState({year:year})
    this.props.setYear(year);
  }

  runStop(){
    this.interval = setInterval(() => {
      console.log('counting')
      if(this.state.play === true){
        if (this.state.year === 2015){
          this.setState({play:false})
        }
        else{
          this.setYear(this.state.year + 1)
        }
      }
      }, 1000);
  }
  
  reStart(){
    console.log('hi')
    this.setState({play:true,year:1985})
    
    this.props.setYear(1985)
  }



  render() {
      return (
        <div style={style}>
          <Row>
          <Col style={{width:'80%'}} span={12}>
              <Slider
                  min={1985}
                  max={2015}
                  value = {this.state.year}
                  onChange={this.updateYear}
              />
          </Col>
          <Col span={2}>
            <Button onClick={this.flipPlay}>{(this.state.play)?<Icon type="pause" />:<Icon type="play-circle" />}</Button>
          </Col>
          <Col span={2}>
              <Button onClick={this.reStart}><Icon type="reload" /></Button>
          </Col>
          </Row>     
        </div>
      );
    }   
}